export const validateEmail = (email?: string) => {
  if (!email) return false;
  return /^[^ ]+@[^ ]+\.[^ ]{2,}$/.test(email);
};
